(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-price"] && !Shopify.designMode) return;
  try {
    ;(() => {
        if (customElements.get('product-price')) return

        // Shopify money formatter: cents -> string, using the shop's format.
        const formatMoney = (cents, format) => {
            const placeholder = /\{\{\s*(\w+)\s*\}\}/
            format = format || '{{amount}}'
            const match = format.match(placeholder)
            if (!match) return format

            const delimit = (precision, thousands = ',', decimal = '.') => {
                const [whole, fraction] = (Number(cents) / 100).toFixed(precision).split('.')
                const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands)
                return fraction ? `${grouped}${decimal}${fraction}` : grouped
            }

            const amount =
                {
                    amount: () => delimit(2),
                    amount_no_decimals: () => delimit(0),
                    amount_with_comma_separator: () => delimit(2, '.', ','),
                    amount_no_decimals_with_comma_separator: () => delimit(0, '.', ','),
                    amount_with_apostrophe_separator: () => delimit(2, "'", '.'),
                    amount_with_space_separator: () => delimit(2, ' ', ','),
                }[match[1]] || (() => delimit(2))

            return format.replace(placeholder, amount())
        }

        // Fire a single 'variant:urlchange' event for pushState / replaceState / back-forward.
        if (!window.__variantUrlWatch) {
            window.__variantUrlWatch = true
            let last = new URLSearchParams(location.search).get('variant')
            const check = () => {
                const id = new URLSearchParams(location.search).get('variant')
                if (!id || id === last) return
                last = id
                window.dispatchEvent(new CustomEvent('variant:urlchange', { detail: { variantId: id } }))
            }
            ;['pushState', 'replaceState'].forEach((method) => {
                const original = history[method]
                history[method] = function (...args) {
                    const result = original.apply(this, args)
                    queueMicrotask(check)
                    return result
                }
            })
            window.addEventListener('popstate', check)
        }

        class ProductPrice extends HTMLElement {
            connectedCallback() {
                this.card = this.closest('product-card')
                this.priceEl = this.querySelector('[data-price]')
                this.compareEl = this.querySelector('[data-price-compare]')
                this.offEl = this.querySelector('[data-price-off]')

                this.onUrlChange = (event) => this.update(event.detail.variantId)
                window.addEventListener('variant:urlchange', this.onUrlChange)

                // Page may already have a different ?variant than first render.
                const urlId = new URLSearchParams(location.search).get('variant')
                if (urlId) this.update(urlId)
            }

            disconnectedCallback() {
                window.removeEventListener('variant:urlchange', this.onUrlChange)
            }

            get variants() {
                if (this._variants) return this._variants

                // 1. Product JSON rendered in the section
                const script = this.card?.querySelector('script.ProductData')
                if (script) {
                    try {
                        const product = JSON.parse(script.textContent)
                        if (String(product.id) === this.dataset.productId) {
                            return (this._variants = product.variants || [])
                        }
                    } catch (e) {}
                }

                // 2. product-card's data store
                return this.card?.data?.product?.value?.variants || []
            }

            update(variantId) {
                const id = String(variantId)
                if (id === this.dataset.variantId) return

                const variant = this.variants.find((v) => String(v.id) === id)
                if (!variant) return // not this product's variant

                this.dataset.variantId = id

                const format = this.dataset.moneyFormat
                const price = Number(variant.price)
                const compare = Number(variant.compare_at_price) || 0
                const pct = compare > price ? Math.round(((compare - price) * 100) / compare) : 0

                this.priceEl.textContent = formatMoney(price, format)

                this.offEl.textContent = pct ? `${pct}% off` : ''
                this.offEl.classList.toggle('hidden', !pct)

                this.compareEl.textContent = pct ? formatMoney(compare, format) : ''
                this.compareEl.classList.toggle('hidden', !pct)
            }
        }

        customElements.define('product-price', ProductPrice)
    })()
  } catch(e) { console.error(e); }
})();

})();
